import { Component, ElementRef, OnInit, OnDestroy, Input,ChangeDetectorRef ,ApplicationRef,NgZone} from '@angular/core';
import { SpinnerService } from './spinner.service';
import { Subscription } from 'rxjs/Rx';
import { ngxLoadingAnimationTypes } from "ngx-loading";

declare var Spinner: any;

@Component({
   selector: 'az-spinner',
   templateUrl: './spinner.component.html'
})
export class SpinnerComponent implements OnInit, OnDestroy {
 
     config: any;
     show: boolean = false;
    private subscription: Subscription = null;


    constructor(private spinnerService: SpinnerService) {}

    ngOnInit() {
       this.initSpinner();
       this.createServiceSubscription();
      
    }

    private initSpinner() {
        this.config = {
            backdropBorderRadius: '14px',
            animationType:ngxLoadingAnimationTypes.threeBounce
        };

    }

    private createServiceSubscription() {
        this.subscription = this.spinnerService.spinnerObservable.subscribe(show => {
            if (show) {
            
           this.startSpinner();
            
            } else {
                this.stopSpinner();
              
            }
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    startSpinner() {
        this.show = true;
      
    }

    stopSpinner() {
        this.show = false;
      ;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/spinner/spinner.component.ts